import React from "react";
import RetailerWidgetConfigurationFormik from "./RetailerWidgetConfigurationFormik/RetailerWidgetConfigurationFormik";
import RetailerWidgetConfigurationFormView from "./RetailerWidgetConfigurationFormView/RetailerWidgetConfigurationFormView";

const initialValues = {
    // captcha: false,
    // questionnaireHeader: "",
    isMultiStoreInventoryOn: false,
    multiStoreInventoryRadius: 50,
    isOnlyOnSpecificPages: false,
    allowedPages: "",
    isHiddenOnSpecificPages: false,
    disallowedPages: "",
    customerAddressMode: false,
    isEducationHidden: true,
    isVisibleOnlyWithItemsInCart: false,
    isItemsRecommendationOptionOn: false,
    shouldIgnoreSpecificProductTypesInventoryCheck: false,
    productTypesToIgnoreInventoryCheck: "",
    isRecommendationsEnabled: false,
};

const RetailerWidgetConfiguration = ({ widgetSettings }) => {
    const settings = {
        // captcha: widgetSettings.captcha ?? initialValues.captcha,
        // questionnaireHeader:
        //     widgetSettings.questionnaireHeader ??
        //     initialValues.questionnaireHeader,
        isMultiStoreInventoryOn:
            widgetSettings.isMultiStoreInventoryOn ??
            initialValues.isMultiStoreInventoryOn,
        multiStoreInventoryRadius:
            widgetSettings.multiStoreInventoryRadius ??
            initialValues.multiStoreInventoryRadius,
        isOnlyOnSpecificPages:
            widgetSettings.isOnlyOnSpecificPages ??
            initialValues.isOnlyOnSpecificPages,
        allowedPages: widgetSettings.allowedPages ?? initialValues.allowedPages,
        isHiddenOnSpecificPages:
            widgetSettings.isHiddenOnSpecificPages ??
            initialValues.isHiddenOnSpecificPages,
        disallowedPages:
            widgetSettings.disallowedPages ?? initialValues.disallowedPages,
        customerAddressMode:
            widgetSettings.customerAddressMode ??
            initialValues.customerAddressMode,
        isEducationHidden:
            widgetSettings.isEducationHidden ?? initialValues.isEducationHidden,
        isVisibleOnlyWithItemsInCart:
            widgetSettings.isVisibleOnlyWithItemsInCart ??
            initialValues.isVisibleOnlyWithItemsInCart,
        isItemsRecommendationOptionOn:
            widgetSettings.isItemsRecommendationOptionOn ??
            initialValues.isItemsRecommendationOptionOn,
        shouldIgnoreSpecificProductTypesInventoryCheck:
            widgetSettings.shouldIgnoreSpecificProductTypesInventoryCheck ??
            initialValues.shouldIgnoreSpecificProductTypesInventoryCheck,
        productTypesToIgnoreInventoryCheck:
            widgetSettings.productTypesToIgnoreInventoryCheck ??
            initialValues.productTypesToIgnoreInventoryCheck,
        isRecommendationsEnabled:
            widgetSettings.isRecommendationsEnabled ??
            initialValues.isRecommendationsEnabled,
        geofencing: !!widgetSettings.geofencing,
    };
    return (
        <RetailerWidgetConfigurationFormik widgetSettings={settings}>
            {(props) => <RetailerWidgetConfigurationFormView {...props} />}
        </RetailerWidgetConfigurationFormik>
    );
};

export default RetailerWidgetConfiguration;
